import { useEffect } from "react";

// Canonical production domain (matches robots.txt / sitemap.xml).
export const SITE_PUBLIC_URL = "https://homeproconnectsc.com";

const upsertMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  const existed = !!el;
  const prev = el ? el.getAttribute("content") : null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  if (content == null) el.remove(); else el.setAttribute("content", content);
  return () => {
    const cur = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!cur) return;
    if (existed) { prev == null ? cur.remove() : cur.setAttribute("content", prev); } else cur.remove();
  };
};

// Per-page SEO for CSR routes: title, description, canonical, OG/Twitter, optional JSON-LD.
// Values restore to the static shell defaults on unmount.
export const usePageMeta = ({ title, description, path, image, type = "website", jsonLd = null }) => {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;
    const cleanups = [];
    const url = path ? `${SITE_PUBLIC_URL}${path}` : null;

    if (description != null) cleanups.push(upsertMeta("name", "description", description));
    if (title) cleanups.push(upsertMeta("property", "og:title", title));
    if (description != null) cleanups.push(upsertMeta("property", "og:description", description));
    cleanups.push(upsertMeta("property", "og:type", type));
    if (title) cleanups.push(upsertMeta("name", "twitter:title", title));
    if (description != null) cleanups.push(upsertMeta("name", "twitter:description", description));
    if (image) {
      cleanups.push(upsertMeta("property", "og:image", image));
      cleanups.push(upsertMeta("name", "twitter:image", image));
      cleanups.push(upsertMeta("name", "twitter:card", "summary_large_image"));
    }
    if (url) cleanups.push(upsertMeta("property", "og:url", url));

    // canonical link
    let link = document.head.querySelector('link[rel="canonical"]');
    const linkExisted = !!link;
    const linkPrev = link ? link.getAttribute("href") : null;
    if (url) {
      if (!link) { link = document.createElement("link"); link.setAttribute("rel", "canonical"); document.head.appendChild(link); }
      link.setAttribute("href", url);
      cleanups.push(() => {
        const c = document.head.querySelector('link[rel="canonical"]');
        if (!c) return;
        if (linkExisted) { linkPrev == null ? c.remove() : c.setAttribute("href", linkPrev); } else c.remove();
      });
    }

    let script = null;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-page-meta", "true");
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }

    return () => {
      document.title = prevTitle;
      cleanups.forEach((fn) => fn());
      if (script) script.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, path, image, type, jsonLd ? JSON.stringify(jsonLd) : null]);
};
